import { render } from "./OnboardingSignatures.vue?vue&type=template&id=774c105e&ts=true"
import script from "./OnboardingSignatures.vue?vue&type=script&lang=ts"
export * from "./OnboardingSignatures.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__